import { productsNode } from '@/api/firebase'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'

// Products must be persisted, so fetch by field results should set on searchProducts
const state = {
    ...async()
}

const getters = {
    GET_ASYNC
}

const mutations = {
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_PRODUCT_BY_ID_ONCE
     *
     *     Retrieve a product by id and return the object with the id included as the field 'id'.
     *     If empty, set false. Does not bind a firebase connection.
     *
     * @param payload.shouldReturn {boolean} - Determine if results should be returned and not set on vuex.
     * @param payload.id {string} - The id of the product to retrieve.
     * @returns {Void / Object}
     */
    async FETCH_PRODUCT_BY_ID_ONCE({ commit }, payload) {
        if (!payload.shouldReturn) {
            commit('REQUEST')
            commit('CLEAR_PRODUCT')
        }
        try {
            const data = (await productsNode.child(payload.id).once('value')).val()
            if (payload.shouldReturn) {
                return data ? { ...data, id: payload.id } : false
            } else {
                commit('SET_PRODUCT', data ? { ...data, id: payload.id } : false)
                commit('SUCCESS')
            }
        } catch (err) {
            if (!payload.shouldReturn) {
                commit('ERROR', err.message)
            } else {
                throw new Error(err.message)
            }
        }
    }

    // =================================== Listener Operations ===================================
}

export { state, getters, mutations, actions }
